import ReasonModal from './ReasonModal';

type Props = {
  onSubmit: (reason: string) => Promise<void>;
  onClose: () => void;
};

const DoNotContactModal = ({ onSubmit, onClose }: Props) => (
  <ReasonModal
    body="Every lifecycle message stops, journeys and transactional, and the journey ends. Use this when the worker asks."
    confirmLabel="Set do not contact"
    failureMessage="Could not set do not contact."
    title="Do not contact this worker?"
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

export default DoNotContactModal;
